import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import countriesApi from 'src/app/api/countriesApi';
import {
  COUNTRY_BLURRED,
  COUNTRY_CHANGE,
  COUNTRY_FOCUSED,
  COUNTRY_GET_SUGGESTIONS,
  countrySet,
  countrySetFocus, countrySetId, countrySetValidationMessage,
  countrySetVisualization, countrySuggestionsError,
  countrySuggestionsSet
} from 'src/app/redux/actions/registration/experience/experienceCountry';
import { firstLetterLowercase } from 'src/app/api/camelize';


function* experienceCountryFocus() {
  yield put(countrySetFocus(true));
}

function* showValidation({ validationMessage }) {
  yield put(countrySetValidationMessage(validationMessage));
  yield put(countrySetVisualization(!!validationMessage));
}

function* suggestCountry({ value, suggestions }) {
  const country = suggestions
    .filter((suggestion) => suggestion.value
      .toLowerCase()
      .trim()
      .includes(value.toLowerCase().trim())
    ).shift();

  if (country) {
    yield put(countrySet(country.value));
    yield put(countrySetId(country.id));
    yield put(countrySetVisualization(false));
  } else {
    const validationMessage = 'Nieprawidłowa nazwa kraju';
    yield showValidation({ validationMessage });
    yield put(countrySetId(0));
  }
}

function* experienceCountryBlur({ payload }) {
  const { highlightedSuggestion, validationMessage } = payload;
  yield put(countrySetFocus(false));

  if (validationMessage) {
    yield showValidation({ validationMessage });
    yield put(countrySetId(0));
    return;
  }

  if (highlightedSuggestion) {
    yield put(countrySetId(highlightedSuggestion.id));
    return;
  }

  yield suggestCountry(payload);
}

function getCountrySuggestions(suggestionsRequest) {
  return function* getCountrySuggestionsGenerator({ payload }) {
    const { query } = payload;

    const getSuggestionWithDispatchers = yield suggestionsRequest(query)
      .then(function* onSuccess({ data }) {
        const { items } = firstLetterLowercase(data[0]);
        return yield put(countrySuggestionsSet(items));
      })
      .catch(function* onError() {
        yield put(countrySuggestionsError());
      });

    yield call(() => getSuggestionWithDispatchers);
  };
}

function* experienceCountryChange({ payload }) {
  const { value, markedAsWrong, apiError, validationMessage } = payload;

  yield put(countrySet(value));

  if (markedAsWrong || apiError) {
    yield put(countrySetVisualization(!!validationMessage));
  }
}


export { experienceCountryFocus, experienceCountryBlur, experienceCountryChange };

export default [
  takeEvery(COUNTRY_CHANGE, experienceCountryChange),
  takeEvery(COUNTRY_FOCUSED, experienceCountryFocus),
  takeEvery(COUNTRY_BLURRED, experienceCountryBlur),
  takeLatest(COUNTRY_GET_SUGGESTIONS, getCountrySuggestions(countriesApi.getCountries))
];
